// Module-singleton QueryClient — exported so non-component code (e.g. axios
// interceptors in api.ts) can invalidate / remove cached queries on auth events.
//
// Centralized to avoid two competing clients between App.tsx and api.ts.

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

export const ME_QUERY_KEY = ['me'] as const;
